module.exports = __webpack_public_path__ + "img/home-2.20b3ab24.jpg";